import React from 'react';
import ReactDOM from 'react-dom/client';
import './static/css/index.scss';
import { Amplify } from 'aws-amplify';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './config';
import config from 'react-global-configuration';
import { sessionStorage } from 'aws-amplify/utils';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: config.get('cognito.userPoolId'),
      userPoolClientId: config.get('cognito.userPoolClientId'),
      identityPoolId: config.get('cognito.identityPoolId'),
      signUpVerificationMethod: config.get('cognito.signUpVerificationMethod'), // 'code' | 'link'
      loginWith: {
        oauth: {}
      }
    },
  },
});

//cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
